import { Card, CardContent, CardMedia, Typography } from '@mui/material';

import React from 'react';

interface ProjectProps {
    background: string;
    categories: string[];
    image?: string;
    title: string;
    fit: string;
    padding: string;
}

const ProjectCard: React.FC<ProjectProps> = ({ title, image, categories, background, fit, padding }) => {
    return (
        <Card
            sx={{
                backgroundColor: 'charcoal',
                borderRadius: '8px 8px 0px 0px',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                height: { md: '22.5rem', sm: '18rem', xs: '15rem', xxl: '55rem' },
                minWidth: '30%',
                width: '100%',
            }}
        >
            <CardMedia
                alt={title}
                component={image ? 'img' : 'div'}
                image={image}
                sx={{
                    alignItems: 'center',
                    background: background,
                    display: 'flex',
                    height: { xs: '65%', xxl: '75%' },
                    justifyContent: 'center',
                    objectFit: fit,
                    objectPosition: fit === 'cover' ? 'top' : 'center',
                    padding: padding,
                    width: '100%',
                }}
            />
            <CardContent
                sx={{
                    height: '35%',
                    padding: '1rem',
                    paddingTop: '1.5rem',
                }}
            >
                <Typography
                    sx={{
                        maxWidth: '100%',
                        mb: '0.375rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                    title={title}
                    variant="h6"
                >
                    {title}
                </Typography>
                <Typography variant="finePrint">{categories.join(' | ')}</Typography>
            </CardContent>
        </Card>
    );
};

export default ProjectCard;
